$(document).ready(function () {
    var languageSwitcher = $('.js-language-switcher');

    if (languageSwitcher.length > 0) {
        var mainContentWrapper = $('main > .inner').eq(0),
            mainContentWrapperPrevSibling = mainContentWrapper.prev(),
            nativeSelect = languageSwitcher.find('select')[0];

        $(languageSwitcher).insertBefore(mainContentWrapper).css('display', 'flex');

        mainContentWrapperPrevSibling.addClass('el-prev-language-switcher');

        nativeSelect.onchange = function () {
            nativeSelect.options[nativeSelect.selectedIndex].value && (window.location = nativeSelect.options[nativeSelect.selectedIndex].value);
        };
    }
});